import * as angular from 'angular';
import { immutableSplice } from 'data/array';
import { CONTENT_TEMPLATE_TYPE } from './BuilderStateService';
// Models
import { ActionType } from '../models/Action';
import { ActionViewModel } from '../models/viewModels/ActionViewModel';
import { OutputViewModel } from '../models/viewModels/OutputViewModel';
import { ContentActionViewModel } from '../models/viewModels/ContentActionViewModel';
import { CardContent, } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/CardContent';
import { FlowViewModel } from '../models/viewModels/FlowViewModel';
// Types
import { BuilderContentType } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/BuilderContentType';
const STATE_MENU_CONTENT_TYPE = 'menu';
const STATE_TEXT_CONTENT_TYPE = 'text';
const BUILDER_POSTMASTER = 'postmaster@builder.msging.net';
export const COPILOT_URL = '/copilot';
export class CopilotAdapterService {
    static $inject = ['BuilderStateService', 'BuilderContentService', 'MessagingHubService'];
    constructor(BuilderStateService, BuilderContentService, MessagingHubService) {
        this.BuilderStateService = BuilderStateService;
        this.BuilderContentService = BuilderContentService;
        this.MessagingHubService = MessagingHubService;
    }
    async getFlow(command) {
        command = encodeURIComponent(command);
        const copilotFlow = await this.getCopilotFlow(command);
        return this.translateFromGpt(copilotFlow);
    }
    async getCopilotFlow(command) {
        const { copilotFlowJson } = await this.MessagingHubService.sendCommand({
            to: BUILDER_POSTMASTER,
            method: 'get',
            uri: `${COPILOT_URL}/flow?userMessage=${command}`,
        });
        return JSON.parse(copilotFlowJson);
    }
    translateFromGpt(states) {
        // Id to guid dictionary
        const idsDictionary = {};
        // Create blocks
        const JsPlumbStates = states.map(state => {
            const jsPlumbState = this.BuilderStateService.createState(CONTENT_TEMPLATE_TYPE, state.title);
            jsPlumbState.isAiGenerated = true;
            idsDictionary[state.id] = jsPlumbState.id;
            this.setBlockPosition(state, jsPlumbState);
            this.addContentToBlocks(state, jsPlumbState);
            return jsPlumbState;
        });
        this.addOutputConditions(states, JsPlumbStates, idsDictionary);
        return JsPlumbStates.reduce((f, state) => {
            f[state.id] = state;
            return f;
        }, new FlowViewModel());
    }
    setBlockPosition(state, jsPlumbState) {
        jsPlumbState.$position = { top: state.position.top + 'px', left: state.position.left + 'px' };
    }
    addContentToBlocks(state, jsPlumbState) {
        switch (state.type) {
            case STATE_TEXT_CONTENT_TYPE:
                const textContent = this.createContent(BuilderContentType.Text, state.message);
                this.addBuiltContentInPosition(textContent, 0, jsPlumbState);
                break;
            case STATE_MENU_CONTENT_TYPE:
                if (this.shouldUseSelectImmediate(state.options)) {
                    const immediateSelectContent = this.createContent(BuilderContentType.SelectImmediate, state.message, state.options);
                    this.addBuiltContentInPosition(immediateSelectContent, 0, jsPlumbState);
                }
                else {
                    const message = this.buildListFromOptions(state.message, state.options);
                    const textContent = this.createContent(BuilderContentType.Text, message);
                    this.addBuiltContentInPosition(textContent, 0, jsPlumbState);
                }
                break;
            default:
                break;
        }
        const chatStateContent = this.createContent(BuilderContentType.ChatState);
        this.addBuiltContentInPosition(chatStateContent, 0, jsPlumbState);
    }
    buildListFromOptions(message, options) {
        const title = message + '</br>';
        return title + options.map((item, index) => ((index + 1) + '. ' + item.option + '</br>')).join('');
    }
    addOutputConditions(states, JsPlumbStates, idsDictionary) {
        states.forEach((state, index) => {
            const jsPlumbState = JsPlumbStates[index];
            switch (state.type) {
                case STATE_TEXT_CONTENT_TYPE:
                    if (state.output) {
                        const output = OutputViewModel.create(idsDictionary[state.output]);
                        jsPlumbState.$conditionOutputs = jsPlumbState.$conditionOutputs.concat(output);
                    }
                    break;
                case STATE_MENU_CONTENT_TYPE:
                    if (this.shouldUseSelectImmediate(state.options)) {
                        const contentId = jsPlumbState.$contentActions[0].action.$id;
                        state.options.forEach(item => {
                            const output = OutputViewModel.createFromContentOption(contentId, item.option);
                            output.stateId = idsDictionary[item.output];
                            jsPlumbState.$conditionOutputs = jsPlumbState.$conditionOutputs.concat(output);
                        });
                    }
                    else {
                        for (let i = 0; i < state.options.length; i++) {
                            const numberOption = '' + (i + 1);
                            const textOption = state.options[i].option;
                            const completeOption = numberOption + '. ' + textOption;
                            const output = OutputViewModel.createFromContentOptions(undefined, [numberOption, textOption, completeOption]);
                            output.stateId = idsDictionary[state.options[i].output];
                            jsPlumbState.$conditionOutputs = jsPlumbState.$conditionOutputs.concat(output);
                        }
                    }
                    break;
                default:
                    break;
            }
        });
    }
    createContent(type, message = undefined, options = undefined) {
        const contentTemplate = this.BuilderContentService.getContentTemplate(type);
        switch (type) {
            case BuilderContentType.Text:
                contentTemplate.content = message;
                break;
            case BuilderContentType.Select:
            case BuilderContentType.SelectImmediate:
                if (typeof contentTemplate.content !== 'string') {
                    contentTemplate.content.text = message;
                    contentTemplate.content.options = options.map(item => ({ 'text': item.option }));
                }
                break;
            default:
                break;
        }
        return this.createContentActionViewModel(contentTemplate, type);
    }
    createContentActionViewModel(contentTemplate, type) {
        return new ContentActionViewModel({
            action: new ActionViewModel({
                type: ActionType.SendMessage,
                settings: angular.copy(contentTemplate),
                $cardContent: this.createCardContent(contentTemplate),
                $typeOfContent: type,
            }),
        });
    }
    shouldUseSelectImmediate(options) {
        if (options.length > 3) {
            return false;
        }
        return !options.some(item => item.option.length > 20);
    }
    addBuiltContentInPosition(content, index, state) {
        state.$contentActions = immutableSplice(state.$contentActions, index, 0, content);
    }
    createCardContent(document = {}, position = 'left', editable = true, deletable = true) {
        return new CardContent({
            document,
            editable,
            deletable,
            position,
        });
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
CopilotAdapterService.$inject = ['BuilderStateService', 'BuilderContentService', 'MessagingHubService'];
